import React from 'react';
import { Route, Switch } from "react-router";
import { List } from "./List";

function Empresas({ match }) {
    const { path } = match;

    return (
        <Switch>
            <Route exact path={path} component={List} />
        </Switch>
    ); 
}


export { Empresas };
